export type LeadModuleLanguage = "da" | "en"

export interface LeadModuleDictionary {
  fieldEmail: string
  fieldEmailPlaceholder: string
  fieldFirstName: string
  fieldFirstNamePlaceholder: string
  fieldCompany: string
  fieldCompanyPlaceholder: string
  fieldPhone: string
  fieldPhonePlaceholder: string
  fieldMessage: string
  fieldMessagePlaceholder: string
  consentCommunication: string
  consentProcess: string
  toggleTermsLink: string
  termsP1: string
  termsP2: string
  termsP3: string
  callToAction: (phone: string) => string
}

const da: LeadModuleDictionary = {
  fieldEmail: "Email",
  fieldEmailPlaceholder: "Indtast email adresse",
  fieldFirstName: "Navn",
  fieldFirstNamePlaceholder: "Indtast dit fornavn",
  fieldCompany: "Virksomhed",
  fieldCompanyPlaceholder: "Indtast virksomhedens navn",
  fieldPhone: "Telefon",
  fieldPhonePlaceholder: "Indtast telefonnummer",
  fieldMessage: "Besked (frivillig)",
  fieldMessagePlaceholder: "Fortæl os lidt om dine behov",
  consentCommunication:
    "Jeg samtykker til at modtage kommunikation fra Clevertrack ApS.",
  consentProcess:
    "Jeg samtykker til at Clevertrack ApS må opbevare og behandle mine personlige data. *",
  toggleTermsLink: "Læs vores betingelser her",
  termsP1:
    "Clevertrack ApS er forpligtet til at beskytte og respektere dit privatliv, og vi anvender kun dine personlige oplysninger til at administrere dit engagement med os og yde de services du har forespurgt fra os. Fra tid til anden vil vi gerne kontakte dig med information om vores services, så vel som andet indhold der kan være interessant for dig. Hvis du giver samtykke til at vi kontakter dig med dette formål, afkryds venligst \"Jeg samtykker til at modtage kommunikation fra Clevertrack ApS.\" herover.",
  termsP2:
    "For at kunne tilbyde dig det forespurgte indhold, skal vi opbevare og behandle dine personlige data. Hvis du samtykker til at vi opbevarer dine data til dette formål, afkryds venligst samtykke-feltet herover.",
  termsP3:
    "Du kan til enhver tid afmelde dig vores kommunikation. For mere information om hvordan du afmelder dig, vores praksiser i forbindelse med anonymitet og hvordan vi er forpligtede til at beskytte og respektere dit privatliv, se da vores privatlivspolitik.",
  callToAction: (phone: string) => `Ring til mig på ${phone}`,
}

const en: LeadModuleDictionary = {
  fieldEmail: "Email",
  fieldEmailPlaceholder: "Enter your email address",
  fieldFirstName: "Name",
  fieldFirstNamePlaceholder: "Enter your first name",
  fieldCompany: "Company",
  fieldCompanyPlaceholder: "Enter your company name",
  fieldPhone: "Phone",
  fieldPhonePlaceholder: "Enter your phone number",
  fieldMessage: "Message (optional)",
  fieldMessagePlaceholder: "Tell us a bit about your needs",
  consentCommunication:
    "I consent to receiving communications from Clevertrack ApS.",
  consentProcess:
    "I consent to Clevertrack ApS storing and processing my personal data. *",
  toggleTermsLink: "Read our terms here",
  termsP1:
    "Clevertrack ApS is committed to protecting and respecting your privacy, and we will only use your personal information to administer your engagement with us and to provide the services you have requested from us. From time to time, we would like to contact you about our services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please check the \"I consent to receiving communications from Clevertrack ApS.\" box above.",
  termsP2:
    "In order to provide you with the requested content, we need to store and process your personal data. If you consent to us storing your data for this purpose, please check the consent box above.",
  termsP3:
    "You can unsubscribe from our communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our privacy policy.",
  callToAction: (phone: string) => `Call me on ${phone}`,
}

export const dictionaries: Record<LeadModuleLanguage, LeadModuleDictionary> = {
  da,
  en,
}

export function getDictionary(language?: string): LeadModuleDictionary {
  return dictionaries[(language as LeadModuleLanguage) ?? "da"] ?? da
}
